import React from 'react'
import CIMSBasicFields from '../../CIMSBasicFields'
import { CustomFieldViewerProps } from './types'
import { useTextCustomFields } from './hooks/useTextCustomFields'
import { useProjectCustomFieldsContext } from '../ProjectCustomFieldsContext'
import { useBooleanCustomFields } from './hooks/useBooleanCustomFields'
import { useDateCustomFields } from './hooks/useDateCustomFields'
import { useNumberCustomFields } from './hooks/useNumberCustomFields'
import { useListCustomFields } from './hooks/useListCustomFields'
import { useReportCustomFields } from './hooks/useReportCustomFields'
import { useEntityCustomFields } from './hooks/useEntityCustomFields'
import { CIMSBasicFieldProps } from '../../CIMSBasicFields/types'

/**
 * components using this component must be wrapped in the {@link CustomFieldProvider}
 */
const CustomFieldViewer: React.FC<CustomFieldViewerProps> = ({
  customFields,
  booleanValueOptions,
  listValueOptions,
  alreadyDisabled,
  recordInactive,
}) => {
  const { fetching } = useProjectCustomFieldsContext()
  const text = useTextCustomFields(customFields?.textValues)
  const booleans = useBooleanCustomFields({
    ...booleanValueOptions,
    booleanValues: customFields?.booleanValues,
    alreadyDisabled,
    recordInactive,
  })
  const dates = useDateCustomFields(customFields?.dateValues)
  const numbers = useNumberCustomFields(customFields?.numberValues)
  const lists = useListCustomFields({
    ...listValueOptions,
    listValues: customFields?.listValues,
    alreadyDisabled,
    recordInactive,
  })
  const reports = useReportCustomFields(customFields?.reportValues)
  const entities = useEntityCustomFields(customFields?.entityValues)
  const hidden = (props: CIMSBasicFieldProps[]) =>
    !props.length || props.every(({ hidden }) => hidden)
  if (
    hidden(text) &&
    hidden(booleans) &&
    hidden(dates) &&
    hidden(numbers) &&
    hidden(lists) &&
    hidden(reports) &&
    hidden(entities)
  )
    return null
  return (
    <CIMSBasicFields
      title="Custom Fields"
      loading={fetching}
      sort
      concise
      fields={[
        ...text,
        ...booleans,
        ...dates,
        ...numbers,
        ...lists,
        ...reports,
        ...entities,
      ]}
    />
  )
}

export default CustomFieldViewer
